import Box from "@mui/material/Box";

// Soft tier tones matching the correspondent portal mockup (light bg + bold
// colored text pill, with a subtle border so the light Silver tone stands out).
const TIER_TONE = {
  Gold: { fg: "#92400e", bg: "#fef3c7", border: "#fcd34d" },
  Silver: { fg: "#475569", bg: "#f1f5f9", border: "#cbd5e1" },
  Bronze: { fg: "#9a3412", bg: "#ffedd5", border: "#fdba74" },
};

export function TierChip({ tier }) {
  if (!tier) return null;
  const t = TIER_TONE[tier] ?? { fg: "#475569", bg: "#f1f5f9", border: "#cbd5e1" };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "999px",
        px: "8px",
        py: "2px",
        fontSize: "11px",
        fontWeight: 700,
        lineHeight: 1.6,
        background: t.bg,
        color: t.fg,
        border: `1px solid ${t.border}`,
      }}
    >
      {tier}
    </Box>
  );
}

export default TierChip;
